import { FC, Fragment, useEffect, useState } from "react";
import { Box, Divider, Grid, Typography } from "@mui/material";
import { FormObjSwitch } from "Utils/SwitchCases";
import CommonFormatter from "Utils/Common.Formatter";
import { FormObjType, HandleChangeType } from "DataTypes/Form";
import { ResultForm, ObservationForm } from "./Data";
import { CommonStyle } from "Components";
import ImgPath from "Constant/Imgs";
import CstmBtn from "Components/CstmBtn";
import { DataActionType } from ".";
import RedoxApi from "Service/Redox.api";
import { useDispatch } from "react-redux";
import { setAlertData, setFormLoader } from "Redux/Screen/Action";
import { PatientInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import { CheckArr, CheckStringEmpty } from "Utils/common";
import DateTime from "Utils/DateTime";

interface AddEditViewModalProps {
  onClose: () => void;
  refreshList: () => void;
  dataAction: DataActionType
}

interface Form2Type {
  id: number;
  observationId: number | null;
  formArr: FormObjType[]
}

const BasicForm2Data: Form2Type = {
  id: 1,
  observationId: null,
  formArr: [...ObservationForm]
};

const UpdateResult: FC<AddEditViewModalProps> = (props) => {
  const dispatch = useDispatch();
  const { patientInfo }: PatientInitialStateType = useSelector(
    (state: any) => state?.patient
  );
  const { dataAction, onClose, refreshList } = props;
  const isEdit = dataAction.action == "EDIT";
  const isView = dataAction.action == "VIEW";
  const isDelete = dataAction.action == "DELETE";
  const [formData, setFormData] =
    useState<FormObjType[]>(structuredClone(ResultForm));
  const [formData2, setFormData2] =
    useState<Form2Type[]>(structuredClone([BasicForm2Data]));

  useEffect(() => {
    handleLoadData();
  }, [dataAction.data?.id, dataAction.action]);

  const handleLoadData: () => void = () => {
    let newFormData = structuredClone(ResultForm);
    const newData = JSON.parse(JSON.stringify(dataAction?.data));
    if (isEdit || isView || isDelete) {
      newFormData = newFormData.map(formEl => {
        return {
          ...formEl,
          inputVal: CheckStringEmpty(newData[formEl.id]),
          readOnly: isView || isDelete
        }
      })
      const newFormData2: Form2Type[] = [];
      CheckArr(newData?.observations).forEach((obsEl: any, i: number) => {
        newFormData2.push({
          id: i + 1,
          observationId: obsEl?.id ?? null,
          formArr: structuredClone(ObservationForm).map(formEl => {
            let inputVal = CheckStringEmpty(obsEl[formEl.id]);
            if (formEl.boxType == "date") {
              inputVal = DateTime.ToLocalDate(inputVal);
            }
            if (formEl.boxType == "single-select") {
              formEl.dropVal = inputVal;
            }
            return {
              ...formEl,
              inputVal,
              readOnly: isView || isDelete
            }
          })
        })
      })
      setFormData2(
        newFormData2.length ?
          newFormData2 :
          structuredClone([BasicForm2Data])
      )
    } else setFormData2(structuredClone([BasicForm2Data]));
    setFormData(newFormData);
  };

  const localHandleChange: (
    props: HandleChangeType,
    formObj: FormObjType
  ) => void = (props, formObj) => {
    const newFormData = structuredClone(formData);
    setFormData(
      CommonFormatter.HandleInputChange2(props, newFormData, formObj)
    );
  };

  const localHandleChange2: (
    props: HandleChangeType,
    formObj: FormObjType,
    form2Obj: Form2Type
  ) => void = (props, formObj, form2Obj) => {
    const newForm2 = structuredClone(formData2);
    newForm2[form2Obj.id - 1].formArr = CommonFormatter.HandleInputChange2(
      props,
      newForm2[form2Obj.id - 1].formArr,
      formObj
    );
    setFormData2(newForm2);
  };

  const handleAddAnotherObservation: () => void = () => {
    setFormData2([
      ...formData2,
      {
        ...structuredClone(BasicForm2Data),
        id: formData2.length + 1
      }
    ])
  };

  const handleDeleteObservation: (indexId: number) => void = (indexId) => {
    let newArr = formData2.filter(el => el.id != indexId);
    newArr = newArr.map((el, i) => {
      return {
        ...el,
        id: i + 1
      }
    })
    setFormData2(newArr);
  };

  const formArrToObj: (
    arr: FormObjType[]
  ) => { [key: string]: any } = (arr) => {
    return arr.reduce((newObj, el) => {
      let inputVal = el.inputVal;
      if (el.boxType == "date") {
        const dateVal = DateTime.ToUTCDate(inputVal);
        inputVal = (dateVal && dateVal.length) ?
          (dateVal + "T00:00:00.000Z") : "";
      }
      if (el.boxType == "single-select") {
        inputVal = el.dropVal ? el.dropVal.toString() : "";
      }
      return {
        ...newObj,
        [el.id]: inputVal
      }
    }, {})
  };

  const handleSave: () => void = async () => {
    let errorCheck = false;
    const newArr = CommonFormatter.HandleValidateForm(formData);
    if (newArr.errorCheck) errorCheck = true;
    setFormData(newArr.formData);
    const newArr2 = formData2.map(el => {
      const newArr3 = CommonFormatter.HandleValidateForm(el.formArr);
      if (newArr3.errorCheck) errorCheck = true;
      return {
        ...el,
        formArr: newArr3.formData
      }
    });
    setFormData2(newArr2);
    if (!errorCheck) {
      dispatch(setFormLoader(true))
      const payload = {
        id: isEdit ? dataAction.data?.id : null,
        ...formArrToObj(newArr.formData),
        patientId: patientInfo.id,
        observations: newArr2.map(el => {
          return {
            id: el.observationId,
            ...formArrToObj(el.formArr)
          }
        })
      }
      const res = await RedoxApi.AddUpdateResult({ data: payload });
      if (res?.success) {
        !isEdit && setFormData(structuredClone(ResultForm));
        !isEdit && setFormData2(structuredClone([BasicForm2Data]));
        dispatch(setAlertData(res?.alert));
        refreshList();
      }
      onClose();
      dispatch(setFormLoader(false))
    }
  };

  const handleDelete: () => void = async () => {
    dispatch(setFormLoader(true))
    const res = await RedoxApi.DeleteResult({ id1: dataAction.data?.id });
    if (res?.success) {
      dispatch(setAlertData(res?.alert));
      refreshList();
    }
    onClose();
    dispatch(setFormLoader(false))
  };

  return (
    <Fragment>
      <Box sx={{ ...sxHeader, ...CommonStyle.sxRow }}>
        <Typography fontWeight="bold" textTransform="capitalize">
          {dataAction.action?.toString().toLowerCase()} Result
        </Typography>
        <Box display={"flex"} alignItems={"center"}>
          <Box
            sx={{ ...CommonStyle.sxRoundIconsMainSm, mr: 1 }}
            onClick={onClose}
          >
            <ImgPath.CloseIcon titleAccess="Close" />
          </Box>
        </Box>
      </Box>
      <Box sx={{ ...sxMain }}>
        <Grid container rowSpacing={1} columnSpacing={2}>
          {formData.map((el) => {
            return (
              <Grid key={el.id} item {...{ md: 4, lg: 3, xl: 3 }}>
                {FormObjSwitch({
                  formObj: el,
                  inputChange: async (props) => localHandleChange(props, el),
                  onClick: async (props) => {
                    setFormData(
                      CommonFormatter.HandleClickChange(props, formData)
                    );
                  }

                })}
              </Grid>
            );
          })}
        </Grid>
        <Divider sx={{ my: 2 }} />
        <Typography variant="body2" fontWeight="bold">
          Observations
        </Typography>
        {formData2.map(formEl2 => {
          return (
            <Fragment key={formEl2.id}>
              <Grid
                container
                rowSpacing={1}
                columnSpacing={2}
                mb={1}
              >
                {formEl2.formArr.map((formEl) => {
                  const showDeleteIcon =
                    formEl.id == "observationUnit" &&
                    formData2.length > 1 &&
                    !isView && !isDelete;
                  const formBox = FormObjSwitch({
                    formObj: formEl,
                    inputChange: async (props) => {
                      localHandleChange2(props, formEl, formEl2)
                    },
                    onClick: async (props) => {
                      const newForm2 = structuredClone(formData2);
                      newForm2[formEl2.id - 1].formArr =
                        CommonFormatter.HandleClickChange(
                          props,
                          newForm2[formEl2.id - 1].formArr
                        );
                      setFormData2(newForm2);
                    }
                  });
                  return (
                    <Grid key={formEl.id} item {...{ md: 4, lg: 3, xl: 3 }}>
                      {showDeleteIcon ? (
                        <Box display="flex">
                          <Box width="80%">{formBox}</Box>
                          <Box
                            width="20%"
                            mt={2}
                            sx={{ ...CommonStyle.sxRowCenter }}
                          >
                            <Box
                              sx={{ ...CommonStyle.sxRoundIconsMainSm }}
                              onClick={() =>
                                handleDeleteObservation(formEl2.id || 0)
                              }
                            >
                              <ImgPath.DeleteOutline titleAccess="Delete" />
                            </Box>
                          </Box>
                        </Box>
                      ) : formBox}
                    </Grid>
                  );
                })}
              </Grid>
              {formEl2.id != formData2.length && (
                <Divider sx={{ ...sxObsDivider }} />
              )}
            </Fragment>
          )
        })}
        <Divider sx={{ my: 2 }} />
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          {isDelete ?
            <Typography
              variant="body2"
              fontWeight="bold"
              letterSpacing="0.1rem"
            >
              <span style={{ color: "red" }}>Note: </span>
              This record will get
              permanently delete from the system. Are you sure?
            </Typography>
            :
            <Box></Box>
          }
          <Box
            display="flex"
            justifyContent="flex-end"
            sx={{ "&>button": { ml: 1 } }}
          >
            {isDelete && (
              <CstmBtn
                label={"Delete"}
                onClick={handleDelete}
                enableFormLoad={true}
              />
            )}
            {(!isView && !isDelete) && (
              <CstmBtn
                label={"Add Another Observation"}
                onClick={handleAddAnotherObservation}
                enableFormLoad={true}
              />
            )}
            {(!isView && !isDelete) && (
              <CstmBtn
                label={"Save"}
                onClick={handleSave}
                enableFormLoad={true}
              />
            )}
            <CstmBtn label={"Close"} onClick={onClose} btnType="border" />
          </Box>
        </Box>
      </Box>
    </Fragment>
  );
};

export default UpdateResult;

const sxHeader = {
  justifyContent: "space-between",
  height: "10%",
  px: 2,
};

const sxMain = {
  height: "85%",
  overflow: "auto",
  px: 2,
};

const sxObsDivider = {
  mb: 1.5,
  borderStyle: "dashed",
};
